import { orderBy } from "@progress/kendo-data-query";
//import { filterBy } from '@progress/kendo-data-query';
import moment from "moment";
import { saveExcel } from "@progress/kendo-vue-excel-export";
// import helpers from '../../shared/fleetbox-helpers';
import gridbase from "../../components/gridComponentBase.js";
import api from "../../services/api";
import cellTemplate from "../../components/grid/cellTemplate/cellTemplate.vue";
import { BNavbarBrand } from "bootstrap-vue";
import { mapGetters } from "vuex";

export default {
	extends: gridbase,
	components: {},
	data: function() {
		return {
			dataReady: false,
			columns: [
				{
					field: "id",
					title: "Id",
					configId: "id",
					width: "100",
					headerCell: "myHeaderTemplate",
					cell: "myCellTemplate",
					editable: false,
					filterable: true,
					format: "link",
					hidden: true
				},
				// {
				// 	field: "name",
				// 	title: "Nome",
				// 	configId: "name",
				// 	width: "120",
				// 	headerCell: "myDriverNameHeaderTemplate",
				// 	cell: "myCellTemplate",
				// 	editable: false,
				// 	filterable: true,
				// 	format: "link"
				// },
				{
					field: "surname_name",
					title: "Cognome e Nome",
					configId: "surnameName",
					width: "240",
					headerCell: "myDriverSurnameHeaderTemplate",
					cell: "myCellTemplate",
					editable: false,
					filterable: true,
					format: "link"
				},
				{
					field: "fiscal_code",
					title: "Codice Fiscale",
					configId: "fiscalCode",
					width: "180",
					headerCell: "myDriverCFHeaderTemplate",
					cell: "myCellTemplate",
					editable: false,
					filterable: true,
					format: "link"
				},
				{
					field: "email",
					title: "Email",
					configId: "email",
					width: "250",
					headerCell: "myHeaderTemplate",
					cell: "myCellTemplate",
					editable: false,
					filterable: true
				},
				{
					field: "mobile_phone_number",
					title: "Cellulare",
					configId: "mobilePhoneNumber",
					width: "130",
					headerCell: "myHeaderTemplate",
					cell: "myCellTemplate",
					editable: false,
					filterable: true
				},
				{
					field: "groups",
					title: "Gruppi",
					configId: "groups",
					width: "250",
					headerCell: "myDriverGroupsHeaderTemplate",
					cell: "myCellTemplate",
					editable: false,
					filterable: true
				},
				{
					field: "employee_register",
					title: "Registro",
					configId: "employeeRegister",
					width: "150",
					headerCell: "myHeaderTemplate",
					cell: "myCellTemplate",
					editable: false,
					filterable: true
				},
				{
					field: "rfid_code",
					title: "Codice rFid",
					configId: "rfidCode",
					width: "150",
					headerCell: "myHeaderTemplate",
					cell: "myCellTemplate",
					editable: false,
					filterable: true
				},
				{
					field: "notes",
					title: "Note",
					configId: "notes",
					width: "300",
					headerCell: "myHeaderTemplate",
					cell: "myCellTemplate",
					editable: false,
					filterable: true
				},
				{
					field: "",
					title: "",
					configId: "",
					width: "",
					headerCell: "",
					cell: "",
					editable: false,
					filterable: true,
					configByPassByField: "is_dismissed"
				},
				{
					field: "is_dismissed",
					title: "Dismissione",
					configId: "isDismissed",
					className: "text-center",
					width: "250",
					format: "boolean",
					headerCell: "myBooleanHeaderTemplate",
					cell: "myCellTemplate",
					editable: false,
					filterable: true
				}
			],

			config: [],
			loading: false,
			items: [],
			canExportGridData: false,

			//table filters
			groupsDataFilters: [],
			groupsDataFiltersSelected: [],
			drivers: [],
			driverNameFilters: [],
			driverNameFilterSelected: [],
			driverSurnameFilters: [],
			driverSurnameFilterSelected: [],
			driverCFFilters: [],
			driverCFFilterSelected: []
		};
	},
	created() {
		this.hasSelectedMode = true;
		this.hasEditableMode = true;

		if (this.settings && this.settings.defaultPageSize && this.settings.defaultPageSize > 0) {
			this.query.pageSize = parseInt(this.settings.defaultPageSize);
		}

		if (this.settings && this.settings.canExportGridData) {
			this.canExportGridData = true;
		}

		this.getConfig();

		this.$nextTick(function() {
			this.getData();
		});

		this.getAllDrivers();
		this.getGroups();
	},
	methods: {
		internalFiltersToUpdate(e) {
			if (e.field == "name") {
				this.driverNameFilterSelected = [];
			}
			if (e.field == "surname") {
				this.driverSurnameFilterSelected = [];
			}
			if (e.field == "fiscal_code") {
				this.driverCFFilterSelected = [];
			}
			if (e.field == "groups") {
				this.groupsDataFiltersSelected = [];
			}
		},
		onGridHeaderFilter() {
			this.getData();
		},
		getGroups: function() {
			var self = this;
			api.getGroupsData().then(res => {
				self.groupsDataFilters = self._.sortBy(
					res
						.filter(function(item) {
							return item.name.length > 0;
						})
						.map(function(item) {
							return {
								id: item.id,
								value: item.name
							};
						}),
					function(item) {
						return item.value ? item.value.toLowerCase() : "";
					}
				);
			});
		},
		getAllDrivers() {
			var self = this;
			api.getDriversData({ page: 0, pageSize: 1000000 }).then(res => {
				self.drivers = res.items.map(function(driver) {
					return {
						id: driver.id,
						name: driver.name,
						surname: driver.surname,
						name_surname_fiscalcode: `${driver.name} ${driver.surname} ${driver.fiscal_code}`,
						fiscal_code: driver.fiscal_code
					};
				});

				self.drivers = self._.sortBy(self.drivers, ["surname", "name"]);
				for (var i = 0; i < self.drivers.length; i++) {
					var driver = self.drivers[i];

					// if (driver.name) {
					// 	var alreadyExist =
					// 		self.driverNameFilters.findIndex(item => {
					// 			return item.id == driver.name.toLowerCase();
					// 		}) >= 0;
					// 	if (!alreadyExist) {
					// 		self.driverNameFilters.push({
					// 			id: driver.name.toLowerCase(),
					// 			value: driver.name.toLowerCase()
					// 		});
					// 	}
					// }

					// if (driver.surname) {
					var alreadyExist =
						self.driverSurnameFilters.findIndex(item => {
							return item.id == `${driver.surname ? driver.surname.toLowerCase() : ""} ${driver.name ? driver.name.toLowerCase() : ""}`;
						}) >= 0;
					if (!alreadyExist) {
						self.driverSurnameFilters.push({
							id: `${driver.surname ? driver.surname.toLowerCase() : ""} ${driver.name ? driver.name.toLowerCase() : ""}`,
							value: `${driver.surname ? driver.surname.toLowerCase() : ""} ${driver.name ? driver.name.toLowerCase() : ""}`
						});
					}
					// }

					if (driver.fiscal_code) {
						var alreadyExist =
							self.driverCFFilters.findIndex(item => {
								return item.id == driver.fiscal_code.toLowerCase();
							}) >= 0;
						if (!alreadyExist) {
							self.driverCFFilters.push({
								id: driver.fiscal_code.toLowerCase(),
								value: driver.fiscal_code.toLowerCase()
							});
						}
					}
				}

				self.driverNameFilters = self._.sortBy(self.driverNameFilters, function(item) {
					return item.value;
				});

				self.driverSurnameFilters = self._.sortBy(self.driverSurnameFilters, function(item) {
					return item.value;
				});

				self.driverCFFilters = self._.sortBy(self.driverCFFilters, function(item) {
					return item.value;
				});
			});
		},
		addDriver() {
			this.$router.push({
				name: "DRIVERS_DETAIL",
				params: {
					id: "0"
				}
			});
		},
		getConfig: function() {
			var self = this;
			api.getViewConfig("fleerun_drivers").then(res => {
				self.config = res;
				if (self.config && self.config.length > 0) {
					var orderedConfigColumn = self._.orderBy(self.config, "order", "asc");

					orderedConfigColumn.forEach(column => {
						var defColumn = self.columns.find(function(f) {
							return f.configId === column.field;
						});

						if (defColumn && column.enabled) {
							defColumn.title = column.label;

							self.columnsToShow.push(defColumn);
						}
					});

					var columnsByPassByField = self._.filter(self.columns, function(item) {
						return item.configByPassByField && item.configByPassByField.length > 0;
					});

					for (var i = 0; i < columnsByPassByField.length; i++) {
						var clBPf = columnsByPassByField[i];
						var columnRootIndex = self.columnsToShow.findIndex(function(cl) {
							return clBPf.configByPassByField == cl.field;
						});

						if (columnRootIndex < 0) columnRootIndex = self.columnsToShow.length;

						self.columnsToShow.splice(columnRootIndex + 1, 0, clBPf);
					}

					self.dataReady = true;
				}
			});
		},
		sortChangeHandler: function(e) {
			this.sort = e.sort;
			this.getData();
		},
		filterChange: function(ev) {
			this.filter = ev.filter;
		},
		pageChangeHandler: function(event) {
			this.skip = event.page.skip;
			this.take = event.page.take;

			if (this.skip === 0) {
				this.query.page = 0;
			}
			this.query.page = this.skip / this.take;

			this.getData();
		},
		groupsToString(groups) {
			if (this._.isNull(groups) === false && this._.isUndefined(groups) === false && this._.isArray(groups) && groups.length > 0) {
				var str = "";
				groups = this._.sortBy(groups, function(gr) {
					return gr.value ? gr.value.toLowerCase() : "";
				});
				groups.forEach(element => {
					str += element.value + ", ";
				});

				str = str.replace(/, $/, "");
				return str;
			}

			return "";
		},
		getData: function() {
			var self = this;
			this.loading = true;

			var data = this._.clone(this.query);

			if (this.columnFilters) {
				for (var i = 0; i < this.columnFilters.length; i++) {
					var clmF = this.columnFilters[i];

					for (var j = 0; j < clmF.filter.filters.length; j++) {
						var filt = clmF.filter.filters[j];
						var field = filt.field;
						var value = filt.value;

						data[field] = value;
					}
				}
			}

			api.getDriversData(data).then(res => {
				self.loading = false;

				self.items = res.items.map(function(item) {
					var row = {};
					self.columns.forEach(function(c) {
						if (c.configId === "surnameName") {
							row[c.field] = `${item.surname ? item.surname.toLowerCase() : ""} ${item.name ? item.name.toLowerCase() : ""}`;
						} else if (c.configId === "groups") {
							row[c.field] = self.groupsToString(item.groups);
						} else {
							row[c.field] = item[c.field];
						}
					});
					return row;
				});

				self.total = res.totalCount;
			});
		},

		isColumnFilterable(field) {
			if (this.columns) {
				var c = this.columns.find(function(f) {
					return f.field == field;
				});

				if (c && c.filterable) {
					return true;
				}
			}

			return false;
		},

		downloadXlsx(type) {
			var self = this;
			if (type == "csv") this.query["format"] = "csv";
			api.exportXlsx("drivers", this.query).then(res => {
				let blob = self.$options.filters.b64toBlob(res.data.fileContents);
				let link = document.createElement("a");
				var url = URL.createObjectURL(blob);
				link.setAttribute("href", url);
				link.setAttribute("download", res.data.fileDownloadName || `Conducenti.${type}`);
				link.style = "visibility:hidden";
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			});
		},
		goTo(dataItem) {
			var id = dataItem.id;

			this.$router.push({
				name: "DRIVERS_DETAIL",
				params: {
					id: id
				}
			});
		}
	},

	computed: {
		result: {
			get: function() {
				var self = this;

				var orderedResult = orderBy(self.items, this.sort);
				//var filteredResult = filterBy(orderedResult, this.filter);
				return orderedResult;
			}
		},
		...mapGetters(["settings"])
	}
};
